import http from '../../utils/http'
import jsonApi from '../../utils/jsonApi'

export const createPickupQueue = data => {
  return http
    .post('pickup_queues', {
      data: {
        type: 'pickup_queues',
        attributes: {
          ...data
        }
      }
    })
    .then(res => res)
}

export const getQueuesCounter = data => {
  return http.get('pickup_queues/pickup_queues_counter').then(res => res)
}

export const deleteQueue = id => {
  return http.delete(`pickup_queues/${id}`).then(res => res)
}

export const editQueue = payload => {
  return http
    .put(`pickup_queues/${payload.id}`, { ...payload.data })
    .then(res => res)
}

export const getPickupQueues = ({ page, params }) => {
  return jsonApi
    .findAll('pickup_queues', {
      params: {
        include:
          'approved_by,pickup_authorization.user,pickup_queue_children.child',
        ...params,
        'q[s]': 'created_at desc',
        'page[number]': page || 1
      }
    })
    .then(res => res)
}
